/**
 * Convercus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomPropertyAttribute } from './custom-property-attribute';
import { Address } from './address';
import { Position } from './position';


export interface Store { 
    address?: Address;
    /**
     * Array of custom properties
     */
    customProperties?: Array<CustomPropertyAttribute>;
    externalReferenceCode?: string;
    id?: string;
    name?: string;
    partnerId?: string;
    position?: Position;
    status?: Store.StatusEnum;
    vatId?: string;
}
export namespace Store {
    export type StatusEnum = 'ACTIVE' | 'INACTIVE';
    export const StatusEnum = {
        ACTIVE: 'ACTIVE' as StatusEnum,
        INACTIVE: 'INACTIVE' as StatusEnum
    };
}


